import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { ExportersTable } from '../components/ExportersTable';
import { Exporter } from '../types';

interface ExportersTabProps {
  exporters: Exporter[];
  loading: boolean;
  onOpenAlertsDrawer: (exporter: Exporter) => void;
  onExporterClick: (exporter: Exporter) => void;
  onMenuOpen: (
    event: React.MouseEvent<HTMLElement>,
    type: 'exporter',
    item: Exporter
  ) => void;
  onAddExporter: () => void;
  onGenerateInstaller: () => void;
  onSync: () => void;
  syncing: boolean;
}

const TableSkeleton = () => (
  <Box>
    {[1, 2, 3, 4, 5].map((i) => (
      <Skeleton
        key={i}
        variant="rectangular"
        height={60}
        sx={{ mb: 1, borderRadius: 1 }}
      />
    ))}
  </Box>
);

export function ExportersTab({
  exporters,
  loading,
  onOpenAlertsDrawer,
  onExporterClick,
  onMenuOpen,
  onAddExporter,
  onGenerateInstaller,
  onSync,
  syncing,
}: ExportersTabProps) {
  if (loading) {
    return <TableSkeleton />;
  }

  return (
    <ExportersTable
      exporters={exporters}
      onOpenAlertsDrawer={onOpenAlertsDrawer}
      onExporterClick={onExporterClick}
      onMenuOpen={onMenuOpen}
      onAddExporter={onAddExporter}
      onGenerateInstaller={onGenerateInstaller}
      onSync={onSync}
      syncing={syncing}
    />
  );
}
